import React from "react";
import { Box, CircularProgress } from "@mui/joy";
import { ReactComponent as VolumeUpIcon } from "../../../assets/svgs/speaker.svg";
import { ReactComponent as VolumeOffIcon } from "../../../assets/svgs/muted.svg";
import { ReactComponent as PlayIcon } from "../../../assets/svgs/play.svg";
import S3_URL from "utils/s3";
import { useLocation } from "react-router-dom";

interface VideoPlayerProps {
  videoSrc: string | null;
  isMuted: boolean;
  isPlaying: boolean;
  videoRef: React.RefObject<HTMLVideoElement | null>;
  onToggleMute: () => void;
  onTogglePlay: () => void;
  videoClassName?: string;
}

export const VideoPlayer: React.FC<VideoPlayerProps> = ({
  videoSrc,
  isMuted,
  isPlaying,
  videoRef,
  onToggleMute,
  onTogglePlay,
  videoClassName,
}) => {
  const location = useLocation();
  const videoPlayCheck = location.state?.isMuted;

  if (!videoSrc) {
    return (
      <Box
        sx={{
          height: "68vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "16px",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      {/* <Box> */}
      <video
        ref={videoRef}
        style={{
          position: "relative",
          inset: 0,
        }}
        className={`object-cover md:object-contain mx-auto w-full h-[68vh] md:h-auto ${videoClassName}`}
        autoPlay={isMuted}
        controls={false}
        loop
        playsInline
        muted={isMuted}
      >
        <source src={`${S3_URL || ""}${videoSrc}`} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <Box
        onClick={onToggleMute}
        sx={{
          position: "absolute",
          top: "8px",
          right: "8px",
          zIndex: 10,
          cursor: "pointer",
          borderRadius: "50%",
        }}
      >
        {isMuted ? (
          <VolumeOffIcon style={{ color: "white", fontSize: "24px" }} />
        ) : (
          <VolumeUpIcon style={{ color: "white", fontSize: "24px" }} />
        )}
      </Box>
      {/* </Box> */}
      {videoPlayCheck === false && !isPlaying && (
        <Box
          onClick={onTogglePlay}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 10,
            cursor: "pointer",
            p: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <PlayIcon />
        </Box>
      )}
    </>
  );
};
export default VideoPlayer;
